module.exports = __webpack_public_path__ + "static/media/first-view-mockup.82962405.png";